const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const jwt = state => state.auth.jwt
const user = state => state.auth.user
const selectOptions = state => state.categories.selectOptions
const expandedCategories = state => state.categories.expandedCategories
const expandedOptions = state => state.categories.expandedOptions
const categories = state => state.categories.categories
const currentPage = state => state.products.currentPage

export {
  config,
  palette,
  isLoading,
  jwt,
  user,
  selectOptions,
  expandedCategories,
  expandedOptions,
  categories,
  currentPage
}
